export default {"src":"/_next/static/media/success-icon.ee9643ec.svg","height":106,"width":106,"blurWidth":0,"blurHeight":0};